import { Link } from 'react-router-dom';
import { comics } from '@/mocks/data';

export default function HotComicsSection() {
  const hotComics = comics.filter((c) => c.featured);

  return (
    <section className="w-full py-14 md:py-20 bg-foreground-950">
      <div className="w-full px-6 md:px-10">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div className="flex items-center gap-3">
            <Link
              to="/category/romance"
              className="px-4 py-1.5 border border-background-200/30 text-background-200 text-xs rounded-full hover:bg-background-200/10 transition-colors cursor-pointer whitespace-nowrap"
            >
              查看全部
            </Link>
            <h2 className="text-xl md:text-3xl font-heading text-white">
              热门<strong>韩漫</strong>推荐
            </h2>
          </div>
          <Link
            to="/category/romance"
            className="hidden md:flex items-center gap-1 text-sm text-primary-400 hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap"
          >
            更多热门 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="flex gap-5 overflow-x-auto pb-4 scrollbar-hide" data-product-shop="">
          {hotComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group block flex-shrink-0 cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-lg mb-3 w-[200px] md:w-[240px] h-[280px] md:h-[330px]">
                <img
                  src={comic.imageUrl}
                  alt={comic.title}
                  title={`${comic.title} - 韩漫屋免费韩漫`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-2 right-2 px-2 py-0.5 bg-primary-500 text-white text-xs rounded-full font-medium">
                  {comic.rating}
                </div>
              </div>
              <div className="space-y-1 w-[200px] md:w-[240px]">
                <h3 className="text-sm font-medium text-background-100 truncate group-hover:text-primary-400 transition-colors">
                  {comic.title}
                </h3>
                <div className="flex items-center justify-between text-xs">
                  <span className="text-foreground-500">{comic.categoryName}</span>
                  <span className="text-foreground-600">更新至{comic.chapters}话</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}